/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Plates_Per_SideInputs */

const en_us2_workout_logging_plates_per_side = /** @type {(inputs: Workout_Logging_Plates_Per_SideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On each side`)
};

const pt_br2_workout_logging_plates_per_side = /** @type {(inputs: Workout_Logging_Plates_Per_SideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em cada lado`)
};

const es_419_workout_logging_plates_per_side = /** @type {(inputs: Workout_Logging_Plates_Per_SideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En cada lado`)
};

const pt_pt2_workout_logging_plates_per_side = /** @type {(inputs: Workout_Logging_Plates_Per_SideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em cada lado`)
};

const fr_fr2_workout_logging_plates_per_side = /** @type {(inputs: Workout_Logging_Plates_Per_SideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De chaque côté`)
};

const de_de2_workout_logging_plates_per_side = /** @type {(inputs: Workout_Logging_Plates_Per_SideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro Seite`)
};

const it_it2_workout_logging_plates_per_side = /** @type {(inputs: Workout_Logging_Plates_Per_SideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per lato`)
};

/**
* | output |
* | --- |
* | "On each side" |
*
* @param {Workout_Logging_Plates_Per_SideInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_plates_per_side = /** @type {((inputs?: Workout_Logging_Plates_Per_SideInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Plates_Per_SideInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_plates_per_side(inputs)
	if (locale === "es-419") return es_419_workout_logging_plates_per_side(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_plates_per_side(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_plates_per_side(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_plates_per_side(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_plates_per_side(inputs)
	return en_us2_workout_logging_plates_per_side(inputs)
});
export { workout_logging_plates_per_side as "workout-logging.plates_per_side" }